import {StrictMode} from 'react';
import {createRoot} from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { registerSW } from 'virtual:pwa-register';

// Suppress Firebase Firestore's internal "Uncaught Error in snapshot listener: permission-denied"
// console spam. The Firebase SDK logs this message before calling the user-provided error
// handler, so there is no way to prevent it from our onSnapshot error callbacks alone.
// These errors are harmless race conditions during Firebase Auth token initialization.
const _origConsoleError = console.error.bind(console);
console.error = (...args: any[]) => {
  const msg = args[0];
  if (
    typeof msg === 'string' &&
    msg.includes('@firebase/firestore') &&
    (msg.includes('permission-denied') || msg.includes('Missing or insufficient permissions'))
  ) {
    return; // silently swallow Firestore permission noise
  }
  _origConsoleError(...args);
};

// Unregister any stale PWA service workers in development mode to prevent caching loops
if (import.meta.env.DEV && 'serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    for (const registration of registrations) {
      const scriptURL = registration.active?.scriptURL || '';
      if (scriptURL && !scriptURL.includes('firebase-messaging-sw.js')) {
        registration.unregister().then((success) => {
          if (success) {
            console.log('[Dev] Service Worker obsoleto desregistrado con éxito.');
          }
        });
      }
    }
  });
}

// Register the unified PWA + Firebase Messaging service worker to cache static assets and handle notifications
registerSW({ immediate: true });


createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
